/**
 * Dev: Mirza Masic
 * Date: 06/15/202 3:11PM
 * 
 * Based on answer on Stack Overflow: https://stackoverflow.com/a/19999868/5681525
 * 
 * Checks if Internet Explorer is used, and if it is alerts user to switch to modern browser
 *  
 */

function msiealert() {

  var ua = window.navigator.userAgent;
  var msie = ua.indexOf("MSIE ");

  if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) { 
    // If Internet Explorer, alert user 
    alert('Internet Explorer is a deprecated browser. We recommend using an actively supported browser for the best experience.');
  }

  return false;
}

msiealert();
